import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { ApiResponse } from '../interfaces';
import { Customer } from '../models';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  constructor(
    public apiService: ApiService,
  ) { }
  /**
   * Buscar usuario
   * @param document numero de documento
   * @param document_type tipo de documento
   */
   queryCustomer(document, document_type): Observable<any> {
    return this.apiService
      .get(
        `${
        this.apiService.customer
        }/customers/?document=${document}&document_type=${document_type}`
      );
  }

  availableCreditCustomer(formValue, society: string): Observable<any> {
    const query = `document=${formValue.identityDocument}&document_type=${formValue.documentType}&paymentMethod=${formValue.aditional.paymentMethod}&society=${society}`;
    return this.apiService
      .get(`${this.apiService.customer}/customers/?${query}`)
      .pipe(map(item => item));
  }

  updateCustomer(id: string, body: Customer): Observable<any> {
    return this.apiService.put(`${this.apiService.customer}/customer/${id}`, body).pipe()
  }

  updateContact(id: string, body: Customer): Observable<any> {
    return this.apiService.put(`${this.apiService.customer}/contacts/${id}`, body).pipe()
  }

  deleteContact(id: string): Observable<any> {
    return this.apiService.delete(`${this.apiService.customer}/contacts/${id}`).pipe()
  }
}
